import { FileUploader } from '@/common/components/FileUploader'
import { checkIsPdf } from '@/common/utils/fileValidator'
import { getFilenameFromUrl } from '@/common/utils/getFilenameFromUrl'
import { ContractData } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLead'
import { UseMutateFunction } from '@tanstack/react-query'
import { useState } from 'react'

interface ContractFileUploaderProps {
  contractFile?: ContractData['file']
  uploadContractFile: UseMutateFunction<void, any, Blob, unknown>
  disabled?: boolean
}

export const ContractFileUploader = ({ contractFile, uploadContractFile, disabled }: ContractFileUploaderProps) => {
  const [file, setFile] = useState<Blob>()
  const [fileName, setFileName] = useState('')

  return (
    <FileUploader
      label=""
      title="Anexe o contrato assinado"
      onChange={(e) => {
        const file = (e.target as HTMLInputElement & { files: FileList }).files?.[0]
        if (!file || !checkIsPdf(file)) {
          return
        }
        if (file) {
          setFileName(file.name)
          setFile(file)
          uploadContractFile(file)
        }
      }}
      className={!file && !contractFile?.url ? 'bg-yellow-op-2 border-none' : undefined}
      name="document"
      accept="application/pdf"
      fileName={fileName ? fileName : contractFile?.url ? getFilenameFromUrl(contractFile.url) : undefined}
      currentFileUrl={file ? URL.createObjectURL(file) : contractFile?.url ? contractFile.url : undefined}
      disabled={disabled}
      data-testid="lead_contract_file_input"
    />
  )
}
